import { render, staticRenderFns } from "./Webservice.vue?vue&type=template&id=02d4ae10"
import script from "./Webservice.vue?vue&type=script&lang=js"
export * from "./Webservice.vue?vue&type=script&lang=js"
import style0 from "./Webservice.vue?vue&type=style&index=0&id=02d4ae10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports